export const CollectLogo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      viewBox="0 0 578 485"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_2015_510)">
        <path
          d="M97.2143 102.537C97.8394 93.598 98.1519 89.1287 100.13 85.8362C101.87 82.9401 104.483 80.6692 107.593 79.349C111.129 77.8482 115.598 78.1607 124.537 78.7858L472.489 103.117C481.428 103.742 485.897 104.055 489.189 106.033C492.086 107.773 494.356 110.385 495.677 113.496C497.178 117.031 496.865 121.501 496.24 130.439L478.884 378.635C478.259 387.574 477.947 392.043 475.968 395.336C474.228 398.232 471.616 400.503 468.506 401.823C464.97 403.324 460.501 403.011 451.562 402.386L103.61 378.055C94.671 377.43 90.2017 377.117 86.9092 375.139C84.0131 373.399 81.7422 370.787 80.422 367.676C78.9212 364.141 79.2337 359.671 79.8588 350.733L97.2143 102.537Z"
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          d="M109.909 93.0194C109.988 91.8832 110.028 91.3151 110.283 90.8984C110.497 90.5472 110.815 90.2709 111.193 90.1071C111.641 89.9127 112.209 89.9524 113.345 90.0318L164.781 93.6286C165.917 93.708 166.486 93.7478 166.902 94.0026C167.253 94.2174 167.53 94.5353 167.694 94.9129C167.888 95.361 167.848 95.9292 167.769 97.0654L166.056 121.566C165.976 122.702 165.936 123.27 165.681 123.687C165.467 124.038 165.149 124.314 164.771 124.478C164.323 124.673 163.755 124.633 162.619 124.553L111.183 120.957C110.047 120.877 109.479 120.837 109.062 120.583C108.711 120.368 108.434 120.05 108.271 119.672C108.076 119.224 108.116 118.656 108.195 117.52L109.909 93.0194Z"
          fill="#F4F6F4"
        />
        <rect
          x="117.172"
          y="103.833"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 117.172 103.833)"
          fill="#9AA9A3"
        />
        <path
          d="M107.467 127.934C107.547 126.798 107.586 126.23 107.841 125.813C108.056 125.462 108.374 125.186 108.751 125.022C109.2 124.828 109.768 124.867 110.904 124.947L162.34 128.543C163.476 128.623 164.044 128.663 164.461 128.917C164.812 129.132 165.088 129.45 165.252 129.828C165.446 130.276 165.407 130.844 165.327 131.98L163.614 156.481C163.535 157.617 163.495 158.185 163.24 158.602C163.025 158.953 162.707 159.229 162.33 159.393C161.882 159.587 161.313 159.548 160.177 159.468L108.741 155.871C107.605 155.792 107.037 155.752 106.62 155.497C106.269 155.283 105.993 154.965 105.829 154.587C105.635 154.139 105.674 153.571 105.754 152.435L107.467 127.934Z"
          fill="#F4F6F4"
        />
        <rect
          x="114.731"
          y="138.747"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 114.731 138.747)"
          fill="#9AA9A3"
        />
        <path
          d="M105.026 162.849C105.105 161.713 105.145 161.145 105.4 160.728C105.614 160.377 105.932 160.101 106.31 159.937C106.758 159.742 107.326 159.782 108.462 159.862L159.898 163.458C161.034 163.538 161.603 163.577 162.019 163.832C162.37 164.047 162.647 164.365 162.811 164.743C163.005 165.191 162.965 165.759 162.886 166.895L161.173 191.395C161.093 192.532 161.053 193.1 160.798 193.517C160.584 193.868 160.266 194.144 159.888 194.308C159.44 194.502 158.872 194.462 157.736 194.383L106.3 190.786C105.164 190.707 104.596 190.667 104.179 190.412C103.828 190.197 103.551 189.88 103.388 189.502C103.193 189.054 103.233 188.486 103.312 187.35L105.026 162.849Z"
          fill="#F4F6F4"
        />
        <rect
          x="112.289"
          y="173.662"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 112.289 173.662)"
          fill="#9AA9A3"
        />
        <path
          d="M102.584 197.764C102.664 196.628 102.703 196.06 102.958 195.643C103.173 195.292 103.491 195.015 103.868 194.852C104.317 194.657 104.885 194.697 106.021 194.776L157.457 198.373C158.593 198.453 159.161 198.492 159.578 198.747C159.929 198.962 160.205 199.28 160.369 199.657C160.563 200.106 160.524 200.674 160.444 201.81L158.731 226.31C158.652 227.447 158.612 228.015 158.357 228.431C158.142 228.783 157.824 229.059 157.447 229.223C156.999 229.417 156.431 229.377 155.294 229.298L103.858 225.701C102.722 225.622 102.154 225.582 101.737 225.327C101.386 225.112 101.11 224.794 100.946 224.417C100.752 223.969 100.791 223.401 100.871 222.264L102.584 197.764Z"
          fill="#F4F6F4"
        />
        <rect
          x="109.848"
          y="208.577"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 109.848 208.577)"
          fill="#9AA9A3"
        />
        <path
          d="M100.143 232.679C100.222 231.543 100.262 230.974 100.517 230.558C100.732 230.207 101.049 229.93 101.427 229.766C101.875 229.572 102.443 229.612 103.579 229.691L155.015 233.288C156.152 233.367 156.72 233.407 157.136 233.662C157.487 233.877 157.764 234.195 157.928 234.572C158.122 235.02 158.082 235.589 158.003 236.725L156.29 261.225C156.21 262.361 156.17 262.929 155.916 263.346C155.701 263.697 155.383 263.974 155.005 264.137C154.557 264.332 153.989 264.292 152.853 264.213L101.417 260.616C100.281 260.537 99.7127 260.497 99.296 260.242C98.9448 260.027 98.6685 259.709 98.5047 259.332C98.3103 258.883 98.35 258.315 98.4295 257.179L100.143 232.679Z"
          fill="#F4F6F4"
        />
        <rect
          x="107.406"
          y="243.492"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 107.406 243.492)"
          fill="#9AA9A3"
        />
        <path
          d="M97.7012 267.594C97.7807 266.457 97.8204 265.889 98.0753 265.473C98.29 265.121 98.6079 264.845 98.9856 264.681C99.4337 264.487 100.002 264.527 101.138 264.606L152.574 268.203C153.71 268.282 154.278 268.322 154.695 268.577C155.046 268.792 155.322 269.109 155.486 269.487C155.681 269.935 155.641 270.503 155.561 271.64L153.848 296.14C153.769 297.276 153.729 297.844 153.474 298.261C153.259 298.612 152.941 298.889 152.564 299.052C152.116 299.247 151.548 299.207 150.411 299.128L98.9755 295.531C97.8393 295.451 97.2712 295.412 96.8545 295.157C96.5033 294.942 96.227 294.624 96.0632 294.246C95.8688 293.798 95.9085 293.23 95.988 292.094L97.7012 267.594Z"
          fill="#F4F6F4"
        />
        <rect
          x="104.965"
          y="278.407"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 104.965 278.407)"
          fill="#9AA9A3"
        />
        <path
          d="M95.2597 302.508C95.3391 301.372 95.3789 300.804 95.6337 300.387C95.8485 300.036 96.1664 299.76 96.544 299.596C96.9922 299.402 97.5603 299.441 98.6965 299.521L150.132 303.118C151.269 303.197 151.837 303.237 152.253 303.492C152.604 303.706 152.881 304.024 153.045 304.402C153.239 304.85 153.199 305.418 153.12 306.554L151.407 331.055C151.327 332.191 151.287 332.759 151.033 333.176C150.818 333.527 150.5 333.803 150.122 333.967C149.674 334.162 149.106 334.122 147.97 334.042L96.534 330.446C95.3978 330.366 94.8297 330.326 94.413 330.072C94.0618 329.857 93.7855 329.539 93.6217 329.161C93.4273 328.713 93.467 328.145 93.5465 327.009L95.2597 302.508Z"
          fill="#F4F6F4"
        />
        <rect
          x="102.523"
          y="313.322"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 102.523 313.322)"
          fill="#9AA9A3"
        />
        <path
          d="M92.8182 337.423C92.8977 336.287 92.9374 335.719 93.1923 335.302C93.407 334.951 93.7249 334.675 94.1026 334.511C94.5507 334.317 95.1188 334.356 96.255 334.436L147.691 338.032C148.827 338.112 149.395 338.152 149.812 338.406C150.163 338.621 150.439 338.939 150.603 339.317C150.798 339.765 150.758 340.333 150.678 341.469L148.965 365.97C148.886 367.106 148.846 367.674 148.591 368.091C148.376 368.442 148.058 368.718 147.681 368.882C147.233 369.076 146.665 369.037 145.528 368.957L94.0925 365.36C92.9563 365.281 92.3882 365.241 91.9715 364.986C91.6204 364.772 91.344 364.454 91.1802 364.076C90.9858 363.628 91.0255 363.06 91.105 361.924L92.8182 337.423Z"
          fill="#F4F6F4"
        />
        <rect
          x="100.082"
          y="348.236"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 100.082 348.236)"
          fill="#9AA9A3"
        />
        <path
          d="M171.759 97.3446C171.838 96.2084 171.878 95.6402 172.133 95.2235C172.348 94.8724 172.666 94.596 173.043 94.4322C173.491 94.2378 174.06 94.2776 175.196 94.357L226.632 97.9538C227.768 98.0332 228.336 98.0729 228.753 98.3278C229.104 98.5426 229.38 98.8605 229.544 99.2381C229.738 99.6862 229.699 100.254 229.619 101.391L227.906 125.891C227.826 127.027 227.787 127.595 227.532 128.012C227.317 128.363 226.999 128.639 226.622 128.803C226.173 128.998 225.605 128.958 224.469 128.879L173.033 125.282C171.897 125.202 171.329 125.163 170.912 124.908C170.561 124.693 170.285 124.375 170.121 123.997C169.927 123.549 169.966 122.981 170.046 121.845L171.759 97.3446Z"
          fill="#F4F6F4"
        />
        <rect
          x="179.022"
          y="108.158"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 179.022 108.158)"
          fill="#9AA9A3"
        />
        <path
          d="M169.318 132.259C169.397 131.123 169.437 130.555 169.692 130.138C169.906 129.787 170.224 129.511 170.602 129.347C171.05 129.153 171.618 129.192 172.754 129.272L224.19 132.869C225.326 132.948 225.894 132.988 226.311 133.243C226.662 133.457 226.939 133.775 227.102 134.153C227.297 134.601 227.257 135.169 227.178 136.305L225.464 160.806C225.385 161.942 225.345 162.51 225.09 162.927C224.876 163.278 224.558 163.554 224.18 163.718C223.732 163.913 223.164 163.873 222.028 163.793L170.592 160.197C169.456 160.117 168.888 160.077 168.471 159.823C168.12 159.608 167.843 159.29 167.68 158.912C167.485 158.464 167.525 157.896 167.604 156.76L169.318 132.259Z"
          fill="#F4F6F4"
        />
        <rect
          x="176.581"
          y="143.073"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 176.581 143.073)"
          fill="#9AA9A3"
        />
        <path
          d="M166.876 167.174C166.955 166.038 166.995 165.47 167.25 165.053C167.465 164.702 167.783 164.426 168.16 164.262C168.608 164.068 169.177 164.107 170.313 164.187L221.749 167.783C222.885 167.863 223.453 167.903 223.87 168.157C224.221 168.372 224.497 168.69 224.661 169.068C224.855 169.516 224.816 170.084 224.736 171.22L223.023 195.721C222.943 196.857 222.904 197.425 222.649 197.842C222.434 198.193 222.116 198.469 221.739 198.633C221.29 198.827 220.722 198.788 219.586 198.708L168.15 195.111C167.014 195.032 166.446 194.992 166.029 194.737C165.678 194.523 165.402 194.205 165.238 193.827C165.044 193.379 165.083 192.811 165.163 191.675L166.876 167.174Z"
          fill="#F4F6F4"
        />
        <rect
          x="174.139"
          y="177.987"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 174.139 177.987)"
          fill="#9AA9A3"
        />
        <path
          d="M164.435 202.089C164.514 200.953 164.554 200.385 164.809 199.968C165.023 199.617 165.341 199.341 165.719 199.177C166.167 198.982 166.735 199.022 167.871 199.102L219.307 202.698C220.443 202.778 221.011 202.817 221.428 203.072C221.779 203.287 222.056 203.605 222.22 203.983C222.414 204.431 222.374 204.999 222.295 206.135L220.581 230.635C220.502 231.772 220.462 232.34 220.207 232.757C219.993 233.108 219.675 233.384 219.297 233.548C218.849 233.742 218.281 233.702 217.145 233.623L165.709 230.026C164.573 229.947 164.005 229.907 163.588 229.652C163.237 229.437 162.96 229.12 162.797 228.742C162.602 228.294 162.642 227.726 162.721 226.59L164.435 202.089Z"
          fill="#F4F6F4"
        />
        <rect
          x="171.698"
          y="212.902"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 171.698 212.902)"
          fill="#9AA9A3"
        />
        <path
          d="M161.993 237.004C162.073 235.868 162.112 235.3 162.367 234.883C162.582 234.532 162.9 234.255 163.277 234.092C163.726 233.897 164.294 233.937 165.43 234.016L216.866 237.613C218.002 237.693 218.57 237.732 218.987 237.987C219.338 238.202 219.614 238.52 219.778 238.897C219.972 239.346 219.933 239.914 219.853 241.05L218.14 265.55C218.061 266.687 218.021 267.255 217.766 267.671C217.551 268.023 217.233 268.299 216.856 268.463C216.408 268.657 215.839 268.617 214.703 268.538L163.267 264.941C162.131 264.862 161.563 264.822 161.146 264.567C160.795 264.352 160.519 264.034 160.355 263.657C160.161 263.209 160.2 262.641 160.28 261.504L161.993 237.004Z"
          fill="#F4F6F4"
        />
        <rect
          x="169.256"
          y="247.817"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 169.256 247.817)"
          fill="#9AA9A3"
        />
        <path
          d="M159.552 271.919C159.631 270.783 159.671 270.214 159.926 269.798C160.14 269.447 160.458 269.17 160.836 269.006C161.284 268.812 161.852 268.852 162.988 268.931L214.424 272.528C215.56 272.607 216.129 272.647 216.545 272.902C216.896 273.117 217.173 273.435 217.337 273.812C217.531 274.26 217.491 274.829 217.412 275.965L215.699 300.465C215.619 301.601 215.579 302.169 215.324 302.586C215.11 302.937 214.792 303.214 214.414 303.377C213.966 303.572 213.398 303.532 212.262 303.453L160.826 299.856C159.69 299.777 159.122 299.737 158.705 299.482C158.354 299.267 158.077 298.949 157.914 298.572C157.719 298.124 157.759 297.555 157.838 296.419L159.552 271.919Z"
          fill="#F4F6F4"
        />
        <rect
          x="166.815"
          y="282.732"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 166.815 282.732)"
          fill="#9AA9A3"
        />
        <path
          d="M157.11 306.834C157.19 305.697 157.229 305.129 157.484 304.713C157.699 304.361 158.017 304.085 158.394 303.921C158.843 303.727 159.411 303.767 160.547 303.846L211.983 307.443C213.119 307.522 213.687 307.562 214.104 307.817C214.455 308.032 214.731 308.349 214.895 308.727C215.089 309.175 215.05 309.743 214.97 310.88L213.257 335.38C213.178 336.516 213.138 337.084 212.883 337.501C212.668 337.852 212.35 338.129 211.973 338.292C211.525 338.487 210.956 338.447 209.82 338.368L158.384 334.771C157.248 334.691 156.68 334.652 156.263 334.397C155.912 334.182 155.636 333.864 155.472 333.486C155.278 333.038 155.317 332.47 155.397 331.334L157.11 306.834Z"
          fill="#F4F6F4"
        />
        <rect
          x="164.373"
          y="317.647"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 164.373 317.647)"
          fill="#9AA9A3"
        />
        <path
          d="M154.669 341.748C154.748 340.612 154.788 340.044 155.043 339.627C155.257 339.276 155.575 339 155.953 338.836C156.401 338.642 156.969 338.681 158.105 338.761L209.541 342.358C210.677 342.437 211.246 342.477 211.662 342.732C212.013 342.946 212.29 343.264 212.454 343.642C212.648 344.09 212.608 344.658 212.529 345.794L210.816 370.295C210.736 371.431 210.696 371.999 210.442 372.416C210.227 372.767 209.909 373.043 209.531 373.207C209.083 373.402 208.515 373.362 207.379 373.282L155.943 369.686C154.807 369.606 154.239 369.566 153.822 369.312C153.471 369.097 153.194 368.779 153.031 368.401C152.836 367.953 152.876 367.385 152.955 366.249L154.669 341.748Z"
          fill="#F4F6F4"
        />
        <rect
          x="161.932"
          y="352.562"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 161.932 352.562)"
          fill="#9AA9A3"
        />
        <path
          d="M233.609 101.67C233.689 100.533 233.729 99.9652 233.983 99.5485C234.198 99.1974 234.516 98.921 234.894 98.7572C235.342 98.5628 235.91 98.6026 237.046 98.682L288.482 102.279C289.618 102.358 290.186 102.398 290.603 102.653C290.954 102.868 291.231 103.185 291.394 103.563C291.589 104.011 291.549 104.579 291.47 105.716L289.756 130.216C289.677 131.352 289.637 131.92 289.382 132.337C289.168 132.688 288.85 132.964 288.472 133.128C288.024 133.323 287.456 133.283 286.32 133.204L234.884 129.607C233.748 129.527 233.179 129.488 232.763 129.233C232.412 129.018 232.135 128.7 231.971 128.322C231.777 127.874 231.817 127.306 231.896 126.17L233.609 101.67Z"
          fill="#F4F6F4"
        />
        <rect
          x="240.873"
          y="112.483"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 240.873 112.483)"
          fill="#9AA9A3"
        />
        <path
          d="M231.168 136.584C231.247 135.448 231.287 134.88 231.542 134.463C231.757 134.112 232.075 133.836 232.452 133.672C232.9 133.478 233.469 133.517 234.605 133.597L286.041 137.194C287.177 137.273 287.745 137.313 288.162 137.568C288.513 137.782 288.789 138.1 288.953 138.478C289.147 138.926 289.108 139.494 289.028 140.63L287.315 165.131C287.235 166.267 287.196 166.835 286.941 167.252C286.726 167.603 286.408 167.879 286.031 168.043C285.582 168.238 285.014 168.198 283.878 168.118L232.442 164.522C231.306 164.442 230.738 164.402 230.321 164.148C229.97 163.933 229.694 163.615 229.53 163.237C229.336 162.789 229.375 162.221 229.455 161.085L231.168 136.584Z"
          fill="#F4F6F4"
        />
        <rect
          x="238.431"
          y="147.398"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 238.431 147.398)"
          fill="#9AA9A3"
        />
        <path
          d="M226.285 206.414C226.364 205.278 226.404 204.71 226.659 204.293C226.874 203.942 227.192 203.666 227.569 203.502C228.017 203.307 228.586 203.347 229.722 203.427L281.158 207.023C282.294 207.103 282.862 207.142 283.279 207.397C283.63 207.612 283.906 207.93 284.07 208.308C284.264 208.756 284.225 209.324 284.145 210.46L282.432 234.96C282.352 236.097 282.313 236.665 282.058 237.082C281.843 237.433 281.525 237.709 281.148 237.873C280.699 238.067 280.131 238.027 278.995 237.948L227.559 234.351C226.423 234.272 225.855 234.232 225.438 233.977C225.087 233.762 224.811 233.445 224.647 233.067C224.453 232.619 224.492 232.051 224.572 230.915L226.285 206.414Z"
          fill="#F4F6F4"
        />
        <rect
          x="233.548"
          y="217.227"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 233.548 217.227)"
          fill="#9AA9A3"
        />
        <path
          d="M223.843 241.329C223.923 240.193 223.963 239.625 224.218 239.208C224.432 238.857 224.75 238.58 225.128 238.417C225.576 238.222 226.144 238.262 227.28 238.341L278.716 241.938C279.852 242.018 280.42 242.057 280.837 242.312C281.188 242.527 281.465 242.845 281.628 243.222C281.823 243.671 281.783 244.239 281.704 245.375L279.99 269.875C279.911 271.012 279.871 271.58 279.616 271.996C279.402 272.348 279.084 272.624 278.706 272.788C278.258 272.982 277.69 272.942 276.554 272.863L225.118 269.266C223.982 269.187 223.413 269.147 222.997 268.892C222.646 268.677 222.369 268.359 222.205 267.982C222.011 267.534 222.051 266.966 222.13 265.829L223.843 241.329Z"
          fill="#F4F6F4"
        />
        <rect
          x="231.107"
          y="252.142"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 231.107 252.142)"
          fill="#9AA9A3"
        />
        <path
          d="M221.402 276.244C221.481 275.108 221.521 274.539 221.776 274.123C221.991 273.772 222.309 273.495 222.686 273.331C223.134 273.137 223.703 273.177 224.839 273.256L276.275 276.853C277.411 276.932 277.979 276.972 278.396 277.227C278.747 277.442 279.023 277.76 279.187 278.137C279.381 278.585 279.342 279.154 279.262 280.29L277.549 304.79C277.469 305.926 277.43 306.494 277.175 306.911C276.96 307.262 276.642 307.539 276.265 307.702C275.816 307.897 275.248 307.857 274.112 307.778L222.676 304.181C221.54 304.102 220.972 304.062 220.555 303.807C220.204 303.592 219.928 303.274 219.764 302.897C219.57 302.449 219.609 301.88 219.689 300.744L221.402 276.244Z"
          fill="#F4F6F4"
        />
        <rect
          x="228.665"
          y="287.057"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 228.665 287.057)"
          fill="#9AA9A3"
        />
        <path
          d="M218.961 311.159C219.04 310.022 219.08 309.454 219.335 309.038C219.549 308.686 219.867 308.41 220.245 308.246C220.693 308.052 221.261 308.092 222.397 308.171L273.833 311.768C274.969 311.847 275.537 311.887 275.954 312.142C276.305 312.357 276.582 312.674 276.745 313.052C276.94 313.5 276.9 314.068 276.821 315.205L275.107 339.705C275.028 340.841 274.988 341.409 274.733 341.826C274.519 342.177 274.201 342.454 273.823 342.617C273.375 342.812 272.807 342.772 271.671 342.693L220.235 339.096C219.099 339.016 218.53 338.977 218.114 338.722C217.763 338.507 217.486 338.189 217.322 337.811C217.128 337.363 217.168 336.795 217.247 335.659L218.961 311.159Z"
          fill="#F4F6F4"
        />
        <rect
          x="226.224"
          y="321.972"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 226.224 321.972)"
          fill="#9AA9A3"
        />
        <path
          d="M216.519 346.073C216.598 344.937 216.638 344.369 216.893 343.952C217.108 343.601 217.426 343.325 217.803 343.161C218.251 342.967 218.82 343.006 219.956 343.086L271.392 346.683C272.528 346.762 273.096 346.802 273.513 347.057C273.864 347.271 274.14 347.589 274.304 347.967C274.498 348.415 274.459 348.983 274.379 350.119L272.666 374.62C272.586 375.756 272.547 376.324 272.292 376.741C272.077 377.092 271.759 377.368 271.382 377.532C270.933 377.727 270.365 377.687 269.229 377.607L217.793 374.011C216.657 373.931 216.089 373.891 215.672 373.637C215.321 373.422 215.045 373.104 214.881 372.726C214.687 372.278 214.726 371.71 214.806 370.574L216.519 346.073Z"
          fill="#F4F6F4"
        />
        <rect
          x="223.782"
          y="356.887"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 223.782 356.887)"
          fill="#9AA9A3"
        />
        <path
          d="M295.46 105.995C295.539 104.858 295.579 104.29 295.834 103.874C296.049 103.522 296.367 103.246 296.744 103.082C297.192 102.888 297.76 102.928 298.897 103.007L350.332 106.604C351.469 106.683 352.037 106.723 352.453 106.978C352.805 107.193 353.081 107.51 353.245 107.888C353.439 108.336 353.399 108.904 353.32 110.041L351.607 134.541C351.527 135.677 351.488 136.245 351.233 136.662C351.018 137.013 350.7 137.289 350.322 137.453C349.874 137.648 349.306 137.608 348.17 137.529L296.734 133.932C295.598 133.852 295.03 133.813 294.613 133.558C294.262 133.343 293.986 133.025 293.822 132.647C293.627 132.199 293.667 131.631 293.747 130.495L295.46 105.995Z"
          fill="#F4F6F4"
        />
        <rect
          x="302.723"
          y="116.808"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 302.723 116.808)"
          fill="#9AA9A3"
        />
        <path
          d="M288.135 210.739C288.215 209.603 288.255 209.035 288.509 208.618C288.724 208.267 289.042 207.991 289.42 207.827C289.868 207.632 290.436 207.672 291.572 207.752L343.008 211.348C344.144 211.428 344.712 211.467 345.129 211.722C345.48 211.937 345.756 212.255 345.92 212.633C346.115 213.081 346.075 213.649 345.996 214.785L344.282 239.285C344.203 240.422 344.163 240.99 343.908 241.407C343.693 241.758 343.376 242.034 342.998 242.198C342.55 242.392 341.982 242.352 340.846 242.273L289.41 238.676C288.273 238.597 287.705 238.557 287.289 238.302C286.937 238.087 286.661 237.77 286.497 237.392C286.303 236.944 286.343 236.376 286.422 235.24L288.135 210.739Z"
          fill="#F4F6F4"
        />
        <rect
          x="295.399"
          y="221.552"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 295.399 221.552)"
          fill="#9AA9A3"
        />
        <path
          d="M283.252 280.569C283.332 279.433 283.372 278.864 283.626 278.448C283.841 278.097 284.159 277.82 284.537 277.656C284.985 277.462 285.553 277.502 286.689 277.581L338.125 281.178C339.261 281.257 339.829 281.297 340.246 281.552C340.597 281.767 340.874 282.085 341.037 282.462C341.232 282.91 341.192 283.479 341.113 284.615L339.399 309.115C339.32 310.251 339.28 310.819 339.025 311.236C338.811 311.587 338.493 311.864 338.115 312.027C337.667 312.222 337.099 312.182 335.963 312.103L284.527 308.506C283.391 308.427 282.822 308.387 282.406 308.132C282.055 307.917 281.778 307.599 281.614 307.222C281.42 306.773 281.46 306.205 281.539 305.069L283.252 280.569Z"
          fill="#F4F6F4"
        />
        <rect
          x="290.516"
          y="291.382"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 290.516 291.382)"
          fill="#9AA9A3"
        />
        <path
          d="M280.811 315.484C280.89 314.347 280.93 313.779 281.185 313.363C281.4 313.011 281.718 312.735 282.095 312.571C282.543 312.377 283.111 312.417 284.248 312.496L335.684 316.093C336.82 316.172 337.388 316.212 337.805 316.467C338.156 316.682 338.432 316.999 338.596 317.377C338.79 317.825 338.751 318.393 338.671 319.53L336.958 344.03C336.878 345.166 336.839 345.734 336.584 346.151C336.369 346.502 336.051 346.779 335.673 346.942C335.225 347.137 334.657 347.097 333.521 347.018L282.085 343.421C280.949 343.341 280.381 343.302 279.964 343.047C279.613 342.832 279.337 342.514 279.173 342.136C278.978 341.688 279.018 341.12 279.098 339.984L280.811 315.484Z"
          fill="#F4F6F4"
        />
        <rect
          x="288.074"
          y="326.297"
          width="21.5977"
          height="3.99984"
          rx="1.99992"
          transform="rotate(4 288.074 326.297)"
          fill="#9AA9A3"
        />
        <g filter="url(#filter1_d_2015_510)">
          <rect
            x="365.515"
            y="107.665"
            width="119.995"
            height="276.001"
            rx="8"
            transform="rotate(4 365.515 107.665)"
            fill="white"
            shapeRendering="crispEdges"
          />
          <rect
            x="376.649"
            y="120.473"
            width="20"
            height="20"
            rx="10"
            transform="rotate(4 376.649 120.473)"
            fill="#FFC9D3"
          />
          <rect
            x="404.023"
            y="130.407"
            width="60"
            height="3.99984"
            rx="1.99992"
            transform="rotate(4 404.023 130.407)"
            fill="#9AA9A3"
          />
          <rect
            x="374.696"
            y="148.405"
            width="20"
            height="20"
            rx="10"
            transform="rotate(4 374.696 148.405)"
            fill="#FFC6F8"
          />
          <rect
            x="402.07"
            y="158.338"
            width="46.9215"
            height="3.99984"
            rx="1.99992"
            transform="rotate(4 402.07 158.338)"
            fill="#9AA9A3"
          />
          <rect
            x="372.743"
            y="176.336"
            width="20"
            height="20"
            rx="10"
            transform="rotate(4 372.743 176.336)"
            fill="#BBFEC8"
          />
          <rect
            x="400.116"
            y="186.27"
            width="60"
            height="3.99984"
            rx="1.99992"
            transform="rotate(4 400.116 186.27)"
            fill="#9AA9A3"
          />
          <rect
            x="370.79"
            y="204.268"
            width="20"
            height="20"
            rx="10"
            transform="rotate(4 370.79 204.268)"
            fill="#FDE8A0"
          />
          <rect
            x="398.163"
            y="214.202"
            width="65.7564"
            height="3.99984"
            rx="1.99992"
            transform="rotate(4 398.163 214.202)"
            fill="#9AA9A3"
          />
          <rect
            x="368.836"
            y="232.2"
            width="20"
            height="20"
            rx="10"
            transform="rotate(4 368.836 232.2)"
            fill="#C5F496"
          />
          <rect
            x="396.21"
            y="242.134"
            width="46.9215"
            height="3.99984"
            rx="1.99992"
            transform="rotate(4 396.21 242.134)"
            fill="#9AA9A3"
          />
          <rect
            x="366.883"
            y="260.132"
            width="20"
            height="20"
            rx="10"
            transform="rotate(4 366.883 260.132)"
            fill="#CCD9FF"
          />
          <rect
            x="394.257"
            y="270.066"
            width="28.1592"
            height="3.99984"
            rx="1.99992"
            transform="rotate(4 394.257 270.066)"
            fill="#9AA9A3"
          />
          <rect
            x="364.93"
            y="288.064"
            width="20"
            height="20"
            rx="10"
            transform="rotate(4 364.93 288.064)"
            fill="#ADFEFC"
          />
          <rect
            x="392.304"
            y="297.997"
            width="65.7564"
            height="3.99984"
            rx="1.99992"
            transform="rotate(4 392.304 297.997)"
            fill="#9AA9A3"
          />
          <rect
            x="362.977"
            y="315.995"
            width="20"
            height="20"
            rx="10"
            transform="rotate(4 362.977 315.995)"
            fill="#D7D7D7"
          />
          <rect
            x="390.351"
            y="325.929"
            width="46.9215"
            height="3.99984"
            rx="1.99992"
            transform="rotate(4 390.351 325.929)"
            fill="#9AA9A3"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_2015_510"
          x="-1.92374"
          y="-0.996822"
          width="579.946"
          height="487.165"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.99992" />
          <feGaussianBlur stdDeviation="39.9984" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2015_510"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.99996" />
          <feGaussianBlur stdDeviation="0.99996" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_2015_510"
            result="effect2_dropShadow_2015_510"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_2015_510"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2015_510"
          x="338.263"
          y="101.665"
          width="154.956"
          height="299.699"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.99992" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2015_510"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2015_510"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
